import { MenuItemProps, useTranslations } from "@harea/component";

export const useLangMenuItems = (): Array<MenuItemProps> => {
    const [FRENCH, ENGLISH] = useTranslations(i18n);
    return [
        {
            ke: "fr",
            label: FRENCH,
            startIcon: <img src={`/assets/img/langs/FR.png`} className="h-4" alt="FR" />
        },
        {
            ke: "en",
            label: ENGLISH,
            startIcon: <img src={`/assets/img/langs/GB.png`} className="h-4" alt="EN" />
        },
    ];
};

const i18n = ["std_french", "std_english"];
